/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lean_Dark_Snail_LookInputs */

const en_lean_dark_snail_look = /** @type {(inputs: Lean_Dark_Snail_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topics`)
};

const de_lean_dark_snail_look = /** @type {(inputs: Lean_Dark_Snail_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themen`)
};

/**
* | output |
* | --- |
* | "Topics" |
*
* @param {Lean_Dark_Snail_LookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lean_dark_snail_look = /** @type {((inputs?: Lean_Dark_Snail_LookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lean_Dark_Snail_LookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lean_dark_snail_look(inputs)
	return de_lean_dark_snail_look(inputs)
});